var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19103 9.48785H14.8538C15.4979 9.48785 15.9274 9.9173 15.9274 10.5615V21.2979C15.9274 21.8347 15.4979 22.3715 14.8538 22.3715H1.97012C1.4333 22.3715 0.896484 21.8347 0.896484 21.2979V10.5615C0.896484 9.9173 1.4333 9.48785 1.97012 9.48785H3.04376V6.48166C3.04376 3.69021 5.08367 1.22084 7.87512 0.898751C11.096 0.57666 13.7801 3.15339 13.7801 6.26694C13.7801 6.91112 13.2433 7.34057 12.7065 7.34057C12.1697 7.34057 11.6329 6.91112 11.6329 6.26694C11.6329 4.22703 9.80767 2.72393 7.76776 3.04602C6.26467 3.36812 5.19103 4.76384 5.19103 6.3743V9.48785ZM9.48558 18.0769V16.6812C10.2371 16.2518 10.7739 15.3928 10.5592 14.4266C10.3445 13.675 9.70031 13.0308 8.94876 12.8161C7.55303 12.494 6.26467 13.4603 6.26467 14.856C6.26467 15.6076 6.69412 16.2518 7.33831 16.6812V18.0769C7.33831 18.7211 7.76776 19.1506 8.41194 19.1506C9.05613 19.1506 9.48558 18.7211 9.48558 18.0769Z",
    fill: "#AEC2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.ce88663191d307389e3a098b0d567c5f.svg";
export { ForwardRef as ReactComponent };